<template>
  <div>
    <vue-toastr ref="notificationToast"></vue-toastr>
    <div class="ibox box-primary">
      <div class="ibox-title with-border"><h3 class="box-title">Allgemeine Informationen</h3></div>
      <div class="ibox-content">
        <spinner v-if="loading"></spinner>
        <div v-else>
          <div class="form-group">
            <div v-if="isAdmin">
              <label class="control-label">Mandant</label>
              <Select2 v-model="dbRecord.client_id" :options="clientOptions" @change="changeClient"/>
            </div>
            <label for="news_title" class="control-label">Post Titel</label>
            <a class="fa fa-question-circle" v-tippy
               content="Dieser dient zum Einen der internen Organisation UND zum Anderen wird dieser Text für App-News-Beiträge als Headline in der Listen- und Detailübersicht angezeigt."></a>
            <input name="news_title"
                   type="text"
                   id="news_title"
                   class="form-control"
                   v-model="dbRecord.news_title">
          </div>
          <br>
          <div class="row">
            <div v-for="channel in channels">
              <div :class="channel.channel === 'magazine' ? 'col-md-12' : 'col-lg-6 col-md-12 col-12'">
                <component :is="channel.channel" :news-hub="dbRecord" :has-app4="hasApp4" :categories="categories"
                           :index="getIndex(channel.channel)"
                           :context="channel"></component>
              </div>
            </div>
          </div>
          <div style="padding-top: 15px">
            <button class="btn btn-block"
                    style="padding: 20px" @click="openModal" :disabled="!dbRecord.is_draft"><i class="fa fa-plus"></i>
              Marketingkanal hinzufügen
            </button>
          </div>
        </div>
      </div>
      <div class="ibox-footer">
        <button id="save-post" type="submit" class="btn btn-secondary" @click="saveRecord('save')"
                :disabled="!dbRecord.news_title">{{ "Post speichern" }}
        </button>
        <button type="submit" class="btn btn-primary" @click="saveRecord('share')"
                :disabled="!dbRecord.news_title" >{{ dbRecord.is_draft ? "Post jetzt teilen" : "Post aktualisieren" }}
         </button>
      </div>
      <choose-channel-modal ref="modal" :media-type="mediaType" :categories="categories"></choose-channel-modal>
    </div>
  </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import ChooseChannelModal from "./modal/ChooseChannelModal";
import VueToastr from "vue-toastr";
import {mapGetters, mapMutations, mapState} from "vuex";
import Shopware from "./channels/Shopware";
import Wordpress from "./channels/Wordpress";
import AddCredentialsModal from "./modal/AddCredentialsModal";
import MobileApp from "./channels/MobileApp";
import Magazine from "./channels/Magazine";
import Instagram from "./channels/Instagram";
import _ from "lodash"
import Spinner from "../common/spinner/Spinner";
import Facebook from "./channels/Facebook";
import news_hub from "../store/modules/news_hub/news_hub";

export default {
  name: 'NewsHubForm',
  components: {
    Spinner,
    MobileApp,
    AddCredentialsModal,
    ChooseChannelModal,
    Modal,
    VueToastr,
    Shopware,
    Wordpress,
    Instagram,
    Facebook,
    Magazine
  },
  props: ['clients', 'isAdmin', 'hasMagazines', 'hasApp4', 'record', 'media', 'user', 'mediaType', 'selections', 'categories'],
  async mounted() {
    this.setIsAdmin(this.isAdmin)
    this.setHasMagazines(this.hasMagazines)
    this.setUser(this.user)
    this.setSelections(this.$props.selections)

    this.dbRecord = this.record;
    await this.firstInit(this.record)

    this.clients.forEach(client => {
      this.clientOptions.push({
        id: client.id,
        text: client.name
      })
    })

    if (this.media) {
      this.setMedia({media: this.media, mediaType: this.mediaType})
    }

    if (this.mediaType) {
      setTimeout(async () => {
            let openModal = false;
            let channelShouldBeCreated = true;

            if (this.channels.length === 0) {
              if (this.mediaType.belongs_to === 'news_blog') {
                this.openModal();
              } else {
                this.addChannel({mediaType: this.mediaType, channel: this.channel, categories: this.categories})
              }
            } else {

              await this.channels.forEach(channel => {
                if (this.mediaType.belongs_to === 'news_blog') {
                  if (!['wordpress', 'shopware'].includes(channel.channel)) {
                    openModal = true;
                  }
                } else {
                  if (channel.channel === this.mediaType.belongs_to) {
                    channelShouldBeCreated = false;
                  }
                }
              })

              if (channelShouldBeCreated) {
                this.addChannel({mediaType: this.mediaType, channel: this.channel, categories: this.categories})
              }

              if (openModal) {
                this.openModal();
              }
            }
          }
          ,
          500
      )
    }
  },
  data() {
    return {
      lodash: _,
      dbRecord: null,
      clientOptions: [],
      loading: false,
    };
  }
  ,
  methods: {
    ...
        mapMutations([
          'setIsAdmin',
          'setHasMagazines',
          'setUser',
          'setMedia',
          'setChannels',
          'firstInit',
          'setClientId',
          'getChannelCredentials',
          'getInternalLinks',
          'getRecord',
          'getChannels',
          'addChannel',
          'addAdditionalContent',
          'setSelections'
        ]),
    openModal() {
      let element = this.$refs.modal.$el
      $(element).modal('show')
    },
    saveRecord(submitType) {
      this.loading = true;

      const isTestSend = submitType === 'test_send';
      const actualSubmitType = isTestSend ? 'save' : submitType;

      axios.patch(`/backend/news_hubs/${this.record.id}`, {
        record: this.dbRecord,
        channels: this.channels,
        submitType: actualSubmitType
      }).then((res) => {
        this.loading = false;
        this.dbRecord.is_draft = res.data.is_draft;

        if (res.data?.redirect) {
          window.location.replace(`/backend/news_hubs/${res.data.redirect}/edit`);
        }

        let that = this;
        if (res.data?.errors) {
          Object.keys(res.data?.errors).forEach(function (key) {
            that.$refs.notificationToast.e(res.data.errors[key], key);
          });
        }

        this.getChannels();

        if ((!res.data.errors || res.data?.errors.length === 0) && this.record.id && !res.data?.redirect) {
          if(submitType === 'share'){
            window.location.replace(`/backend/news_hubs/${this.record.id}/edit?shared=true`);
          }else if(isTestSend){
            window.location.replace(`/backend/news_hubs/${this.record.id}/edit?test_send=true`);
          }else{
            window.location.replace(`/backend/news_hubs/${this.record.id}/edit?success=true`);
          }
        }
      }).catch((error) => {
        this.loading = false;
        this.getChannels();

        if (error.response?.data?.error_message) {
          this.$refs.notificationToast.e(error.response.data.error_message, 'Fehler');
        } else {
          this.$refs.notificationToast.e('Bitte versuchen Sie es noch einmal.', 'Fehler');
        }
      })
    },
    changeClient() {
      if (this.dbRecord) this.setClientId(this.dbRecord.client_id)
      this.getChannelCredentials()
      this.getInternalLinks()
      this.getChannels()
      this.getRecord()
    },
    getIndex(channelName) {
      let index = 0;
      this.channels.forEach((item, i) => {
        if (item.channel === channelName) {
          index = i
        }
      })
      return index;
    }
  }
  ,
  computed: {
    ...
        mapGetters({
          channels: 'getChannels',
          channelCredentials: 'getChannelCredentials'
        })
  }
}
</script>

<style scoped>
</style>
<style>
.ckeditor-wrapper .ck-content {
  min-height: 300px;
}
</style>
